<template>
  <input-widget :model="model" :attribute="attribute" type="select2" :disabled="disabled" display-field="${item.name}"
                :hint="hint" :label="label" :options="{placeholder: $t('Tax Status')}" :items="taxStatuses"
                :rules="rules"/>
</template>


<script>
  import InputWidget from "./../components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";

  const {mapState} = createNamespacedHelpers('global');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "TaxStatusSelectInputWidget",
    components: {InputWidget},
    props: {
      model: {
        type: Object,
        required: true
      },
      attribute: {
        type: String,
        required: true
      },
      items: {
        type: Array,
        default: () => []
      },
      options: {
        type: Object,
        default: () => {
          return {};
        }
      },
      label: {
        type: [String, Boolean],
        default: null
      },
      hint: {
        type: [Boolean, String],
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      rules: {
        type: [String, Object],
        default: null,
        required: false
      },
    },
    computed: {
      ...mapState(['taxStatuses']),
    }
  }
</script>

<style scoped>

</style>
